import React from 'react'
import { makeStyles } from '@mui/styles'
import { Typography } from '@mui/material'

import { withModal } from 'utils/providers/ModalProvider'

import modals from 'constants/modals'

import { DialogButtons } from 'shared'

import { BaseDialog } from 'shared'

import {
  BaseModalComponentType,
  ModalNameToModalMap,
} from 'components/modals/types'

const useStyles = makeStyles(() => {
  return {
    dialog: {
      '& .base-dialog-header': {
        marginBottom: 12,
        '& h2': {
          fontSize: '24px',
          fontWeight: '700',
          lineHeight: '24px',
        },
      },
    },
  }
})

const LeaveModal = ({
  isOpen,
  closeModal,
  payload,
}: BaseModalComponentType & {
  payload: ModalNameToModalMap['leaveModal']
}) => {
  const classes = useStyles()
  const { onLeave = () => null } = payload || {}

  return (
    <BaseDialog
      open={isOpen}
      onClose={closeModal}
      title="Are you sure you want to leave this page?"
      className={classes.dialog}
    >
      <Typography variant="subtitle1">
        You have unsaved changes that will be lost
      </Typography>

      <DialogButtons
        onCancel={closeModal}
        onSubmit={onLeave}
        submitTitle="Continue"
      />
    </BaseDialog>
  )
}

export default withModal(modals.leaveModal)(LeaveModal)
